import React from 'react';

const ScrollArea = ({ children, className = '', style = {} }) => {
 return (
 <div
 className={`overflow-y-auto max-h-[300px] custom-scrollbar ${className}`}
 style={{ ...style }}
 >
 {children}
 </div>
 );
};

export default ScrollArea;



